module.exports = __webpack_public_path__ + "img/sms-send-success.4ad5b055.png";